import $http from "@/plugins/axios";
import { Subject } from "rxjs";

const Base_NLP_Service = (name) => {
    return {
        search (scenarioId, filter) {
            return $http.get(`scenarios/${scenarioId}/nlp/${name}/`, { params: filter })
        },
        create (scenarioId, model) {
            return $http.post(`scenarios/${scenarioId}/nlp/${name}/`, model)
        },
        read (scenarioId, itemId) {
            return $http.get(`scenarios/${scenarioId}/nlp/${name}/${itemId}/`)
        },
        update (scenarioId, itemId, model) {
            return $http.patch(`scenarios/${scenarioId}/nlp/${name}/${itemId}/`, model)
        },
        replace (scenarioId, itemId, model) {
            return $http.put(`scenarios/${scenarioId}/nlp/${name}/${itemId}/`, model)
        },
        delete (scenarioId, itemId) {
            return $http.delete(`scenarios/${scenarioId}/nlp/${name}/${itemId}/`)
        }
    }
}

const IntentService = Base_NLP_Service('intent')
const EntityService = Base_NLP_Service('entity')
const SampleService = Base_NLP_Service('sample')
const EntitySampleService = Base_NLP_Service('entity-sample')
const IntentSampleService = Base_NLP_Service('intent-sample')
const DictionaryService = Base_NLP_Service('dictionary')

const KeywordService = {
    search (scenarioId, filter) {
        return $http.get(`scenarios/${scenarioId}/nlp/keyword/`, { params: filter })
    },
    create (scenarioId, entity_label, model) {
        return $http.post(`scenarios/${scenarioId}/nlp/keyword/${entity_label}/`, model)
    },
    replace (scenarioId, entity_label, keyword_code, model) {
        return $http.put(`scenarios/${scenarioId}/nlp/keyword/${entity_label}/${keyword_code}/`, model)
    },
    delete (scenarioId, entity_label, keyword_code) {
        return $http.delete(`scenarios/${scenarioId}/nlp/keyword/${entity_label}/${keyword_code}/force-delete/`)
    }
}

const TrainService = {
    trainingStatusChange: new Subject(),
    train (scenarioId) {
        return $http.post(`scenarios/${scenarioId}/nlp/train/`).then(
            result => {
                TrainService.status(window.vueapp.$route.params.scenarioId)
                return Promise.resolve(result)
            },
            error => Promise.reject(error)
        )
    },
    status (scenarioId) {
        return $http.get(`scenarios/${scenarioId}/nlp/train/status/`).then(
            result => {
                TrainService.trainingStatusChange.next({
                    training: result.data.status !== -1 && result.data.status !== 2,
                    lastTrain: result.data.last_success_time
                })
                return Promise.resolve(result)
            },
            error => Promise.reject(error)
        )
    }
}

TrainService.trainingStatusChange.subscribe(data => {
    if (data.training) {
        setTimeout(() => {
            TrainService.status(window.vueapp.$route.params.scenarioId)
        }, 2000)
    }
})

const NLP_Service = {
    IntentService,
    EntityService,
    SampleService,
    EntitySampleService,
    IntentSampleService,
    TrainService,
    KeywordService,
    DictionaryService,
    getData (scenarioId) {
        return $http.get(`scenarios/${scenarioId}/nlp/`)
    },
    importData (scenarioId, formData) {
        return $http.post(`scenarios/${scenarioId}/nlp/manage/import-app/`, formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    exportData (scenarioId) {
        return $http.post(`scenarios/${scenarioId}/nlp/manage/export-app/`, { application: true })
    },
    deleteData (scenarioId) {
        return $http.post(`scenarios/${scenarioId}/nlp/manage/cleanup-app/`)
    },
    importSamplesExcel (scenarioId, formData) {
        return $http.post(`scenarios/${scenarioId}/nlp/manage/import-samples-excel/`, formData)
    }
}

export default NLP_Service
